import { addPage } from "./addPage";
import obsDoc from "./obsDoc";
import { setFontt } from "./setFontt";

function getStringInfo(str, bold, italic, doc) {
  var letters = [];
  for (var i = 0; i < str.length; i++) {
    //change bold setting if need be
    if (str[i] === "|") {
      bold = !bold;
    }
    //change italic setting if need be
    else if (str[i] === "`") {
      italic = !italic;
    }
    // add normal letter with props
    else {
      //set the correct font so width is correct
      setFontt(doc, false, bold, italic);
      const width = doc.getTextWidth(str[i]);
      letters.push({ char: str[i], bold, italic, width });
    }
  }

  return letters;
}

function getLineIndexes(wordInfo, cursorX, pageWidth) {
  var lastSpace = { width: 0, index: 0 };
  var lineIndexes = [0];
  var currentLineWidth = cursorX;

  wordInfo.forEach((ltr, idx) => {
    currentLineWidth += ltr.width;
    if (currentLineWidth >= pageWidth) {
      //save its index for line splitting
      lineIndexes.push(lastSpace.index);
      //reset current line width
      currentLineWidth = cursorX + (currentLineWidth - lastSpace.width);
    }
    if (ltr.char === " ") {
      lastSpace = { width: currentLineWidth, index: idx };
    }
  });

  lineIndexes.push(wordInfo.length - 1);

  return lineIndexes;
}

function getLines(wordInfo, lineIndex) {
  var lines = [];
  for (var i = 0; i < lineIndex.length; i++) {
    if (i > 0) {
      //if its the last one just split to end
      if (i === lineIndex.length - 1) {
        lines.push(wordInfo.slice(lineIndex[i - 1]));
      }
      //else split in the middle
      else {
        lines.push(wordInfo.slice(lineIndex[i - 1], lineIndex[i] + 1));
      }
    }
  }
  // console.log(lines);

  return lines;
}

function printLine(x, y, wordInfo, doc) {
  wordInfo.forEach((ltr, idx) => {
    setFontt(doc, false, ltr.bold, ltr.italic);
    //if first character isn't a space then add text
    if (!(idx === 0 && ltr.char === " ")) {
      doc.text(x, y, ltr.char);
      x += ltr.width;
    }
  });
}

async function printLines(lines, doc, cursorY, pageHeight) {
  for (var i = 0; i < lines.length; i++) {
    //print the line
    printLine(obsDoc.xPosition, cursorY, lines[i], doc);

    //check to see if next line should be on the next page
    if (cursorY + obsDoc.lineSpacing > pageHeight) {
      cursorY = await addPage(doc, cursorY);
    }
    //else just go to next line
    else {
      cursorY += obsDoc.lineSpacing;
    }
  }

  return cursorY;
}

export async function addFormattedText(doc, cursorY, str) {
  const pageHeight = doc.internal.pageSize.height - 1; // Get page height minus some
  const pageWidth = doc.internal.pageSize.width - 1;

  var bold = false;
  var italic = false;

  // console.log(str);
  var lineBreaks = str === undefined ? [] : str.toString().split(/\n/g) || [];

  for (var i = 0; i < lineBreaks.length; i++) {
    var wordInfo = getStringInfo(lineBreaks[i], bold, italic, doc);
    const lineIndexes = getLineIndexes(wordInfo, obsDoc.xPosition, pageWidth);
    const lines = getLines(wordInfo, lineIndexes);

    cursorY = await printLines(lines, doc, cursorY, pageHeight);
  }

  //reset font
  setFontt(doc, false, false, false);

  return cursorY;
}
